import { Box, Button, Divider, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import { InstallPwaDialogResultReason } from "./InstallPwaDialog";

type InstallPwaDialogActionInstructionsProps = {
    action1: ReactNode;
    action2: ReactNode;
    onClose: (reason: InstallPwaDialogResultReason) => void;
};

export default function InstallPwaDialogActionInstructions({
    action1,
    action2,
    onClose
}: InstallPwaDialogActionInstructionsProps) {
    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                marginLeft: 0
            }}>
            <Divider variant="middle" />
            <Box sx={{
                marginLeft: 2,
                marginTop: 3
            }}>
                <Typography variant="subtitle1">To install this app:</Typography>

                <ul>
                    <li>
                        <span style={{ display: "flex", alignItems: "center" }}>
                            {action1}
                        </span>
                    </li>
                    <li>
                        {action2}
                    </li>
                </ul>
            </Box>
            <Box
                sx={{
                    width: "100%",
                    textAlign: "right"
                }}>
                <Button onClick={() => onClose("disable")}>Don't Remind Me Again</Button>
                <Button onClick={() => onClose("postpone")} color="secondary">Ok</Button>
            </Box>
        </Box>
    );
}
